import { BaseImService } from "../base";
import TencentCloudChat from "@tencentcloud/chat";
import TIMUploadPlugin from "tim-upload-plugin";
import { EMIT_MAP } from "../constants";
import { MESSAGE_TYPE } from "./constants";
import { handleMessageData, convertToIMMessage } from "./utils";
import { handleRevokeMessageByServer } from "@saas/server-api/src/chat";
class TIMIMService extends BaseImService {
  constructor(config) {
    super();
    this.config = config;
    this.client = null;
    this.isReady = false;
    this.isLogin = false;
    const SDKAppID = config.sdkAppId; // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
    // 1、创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
    this.client = TencentCloudChat.create({
      SDKAppID,
    }); // SDK 实例通常用 chat 表示
    this.sendMessageStatus = {};
    // this.client.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
    this.client.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
    // 注册腾讯云即时通信 IM 上传插件
    this.client.registerPlugin({ "tim-upload-plugin": TIMUploadPlugin });
    this.registerListener();

    // 2、登录 +加入课堂（需要先加入课堂所在的IM群组）
    this.timClientLogin();
  }
  registerListener() {
    this.client.on(TencentCloudChat.EVENT.MESSAGE_MODIFIED, () => {
      console.log("==zy==MESSAGE_MODIFIED");
    });
    this.client.on(
      TencentCloudChat.EVENT.MESSAGE_REVOKED,
      this.onMessageRevoked.bind(this)
    );
    this.client.on(TencentCloudChat.EVENT.MESSAGE_EXTENSIONS_UPDATED, () => {
      console.log("==zy==MESSAGE_EXTENSIONS_UPDATED");
    });
    this.client.on(TencentCloudChat.EVENT.MESSAGE_REACTIONS_UPDATED, () => {
      console.log("==zy==MESSAGE_REACTIONS_UPDATED");
    });
    // this.client.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, () => {
    //   console.log("==zy==CONVERSATION_LIST_UPDATED");
    // });
    this.client.on(
      TencentCloudChat.EVENT.SDK_NOT_READY,
      this.onNotReady.bind(this)
    );
    this.client.on(TencentCloudChat.EVENT.SDK_READY, this.onReady.bind(this));
    this.client.on(
      TencentCloudChat.EVENT.MESSAGE_RECEIVED,
      this.onMessageReceived.bind(this)
    );
    this.client.on(
      TencentCloudChat.EVENT.MESSAGE_MODIFIED,
      this.onMessageModified.bind(this)
    );
    this.client.on(
      TencentCloudChat.EVENT.KICKED_OUT,
      this.onKickedOut.bind(this)
    );
  }
  joinTimGroup() {
    const groupId = String(this.config.classId);

    return this.client
      .joinGroup({
        groupID: groupId,
        type: TencentCloudChat.TYPES.GRP_PUBLIC,
      })
      .then(
        (res) => {
          switch (res.data.status) {
            case TencentCloudChat.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
            case TencentCloudChat.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
              return Promise.resolve();
            case TencentCloudChat.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意,业务上认为失败
            default:
              return Promise.reject(res);
          }
        },
        (error) => {
          console.log("joinGroup-error======", error);
          if (error.code === 10013) {
            // 被邀请加入的用户已经是群成员,也表示成功
            return Promise.resolve();
          }
          if (error.code === -12) {
            // Join Group succeed; But the type of group is not AVChatRoom
            return Promise.resolve();
          }
          return Promise.reject(error);
        }
      );
  }
  async timClientLogin() {
    try {
      await this.login();
      console.log("登录成功");
      // 不加课堂也可以
      // this.joinTimGroup()
      //   .then((res) => {
      //     console.log("加入课堂成功", res);
      //     // 获取个人信息
      //     // const myinfo = this.getGroupMemberProfile({
      //     //   userIDList: [this.config.userID],
      //     // });
      //   })
      //   .catch((error) => {
      //     console.error("加入课堂失败:", error);
      //   });
    } catch (error) {
      console.error("登录失败:", error);
    }
  }
  login() {
    return new Promise((resolve, reject) => {
      const userID = this.config.userID; // 您的 userID
      const userSig = this.config.userSig; // 用户登录即时通信 IM 的密码，其本质是对 UserID 等信息加密后得到的密文
      this.client
        .login({ userID, userSig })
        .then((imResponse) => {
          console.log("登陆成功");
          console.log(imResponse.data); // 登录成功
          this.isLogin = true;
          if (imResponse.data.repeatLogin === true) {
            // 标识账号已登录，本次登录操作为重复登录。
            console.log(imResponse.data.errorInfo);
          }
          resolve(imResponse.data);
        })
        .catch((imError) => {
          this.isLogin = false;
          console.warn("登陆失败:", imError);
          reject(imError);
        });
    });
  }
  logout() {
    this.client.logout();
  }
  onReady(event) {
    console.log("onReady>>>>>>");
    this.isReady = true;
    this._emit(EMIT_MAP.onReady);
  }
  onNotReady(event) {
    console.log("onNotReady>>>>>>");
    this.isReady = false;
    this._emit(EMIT_MAP.onNotReady);
  }
  //SDK 收到推送的单聊、群聊、群提示、群系统通知的新消息，接入侧可通过遍历 event.data 获取消息列表数据并渲染到页面。
  onMessageReceived(event) {
    const messages = event.data;
    const groupId = String(this.config.classId);
    messages.forEach((message) => {
      // 群组消息
      if (message.conversationType === TencentCloudChat.TYPES.CONV_GROUP) {
        if (message.to === groupId) {
          const { from, nick, type, payload, cloudCustomData = "{}" } = message;
          let cloudCustomDataObj = {};
          try {
            cloudCustomDataObj = JSON.parse(cloudCustomData);
          } catch (error) {
            cloudCustomDataObj = {};
          }
          // 如果是当前群组
          const elements = message.getElements();
          if (elements.length) {
            elements.forEach(async (element) => {
              if (element.type === "TIMCustomElem") {
                // 自定义消息
                const { data, extension } = element.content;
                if (extension === "TXWhiteBoardExt") {
                  // 是白板的自定义消息
                  if (message.from != this.config.userID) {
                    // 并且发消息的人不是自己
                    // 设置为同步，保证实时数据在Sketch能够watch到
                    this._emit(EMIT_MAP.onBoardMessageReceived, data);
                  }
                } else if (extension === "MGLiveRoomExt") {
                  // 是直播的自定义消息
                  let msg = JSON.parse(data);
                  msg = {
                    ...msg,
                    userId: message.from,
                    lessonId: cloudCustomDataObj.lessonId || "",
                  };
                  this._emit(EMIT_MAP.onRecvMGLiveRoomCustomMsg, msg);
                } else if (
                  extension === "MGMaterialFileExt" ||
                  (data && JSON.parse(data).msg_source === 1)
                ) {
                  // 是素材中心的自定义消息
                  this._emit(
                    EMIT_MAP.onLiveGroupChatMessageReceived,
                    this.handleChatMsg(this.handleMessageType(message))
                  );
                }
              } else if (element.type === TencentCloudChat.TYPES.MSG_TEXT) {
                if (isFilterMessage(message, this.config)) {
                  return;
                }
                this._emit(
                  EMIT_MAP.onLiveGroupChatMessageReceived,
                  this.handleChatMsg(this.handleMessageType(message))
                );
                // 文本消息
                const res = {
                  from,
                  payload: element.content,
                  type: "text",
                };
                this._emit(EMIT_MAP.onMessageReceived, res);
              } else {
                if (isFilterMessage(message, this.config)) {
                  return;
                }
                const typeList = [
                  TencentCloudChat.TYPES.MSG_IMAGE,
                  TencentCloudChat.TYPES.MSG_FILE,
                ];
                if (typeList.includes(element.type)) {
                  this._emit(
                    EMIT_MAP.onLiveGroupChatMessageReceived,
                    this.handleChatMsg(this.handleMessageType(message))
                  );
                }
              }
            });
          }
        } else {
          // 其他群组消息自行处理，在互动白板的场景中可以忽略其他群组的消息
        }
      } else if (message.conversationType === TencentCloudChat.TYPES.CONV_C2C) {
        // C2C消息
        // c2c消息在互动白板的场景中可以直接忽略
      }
    });

    // this._emit(EMIT_MAP.onMessageReceived);
  }
  // sdk 收到撤回消息通知
  onMessageRevoked(event) {
    console.log("==zy==MESSAGE_revoked");
    console.log(event);
    this._emit(EMIT_MAP.onMessageRevoked, event);
  }
  handleMessageType(message) {
    message.type = MESSAGE_TYPE[message.type];
    return message;
  }
  handleChatMsg(message) {
    return handleMessageData(message);
  }
  // SDK 收到消息被修改的通知，消息发送方可通过遍历 event.data 获取消息列表数据并更新页面上同 ID 消息的内容。
  onMessageModified(event) {
    this._emit(EMIT_MAP.onMessageModified);
  }
  onKickedOut(event) {
    console.log("kickedOute", event.data.type);
    // TencentCloudChat.TYPES.KICKED_OUT_MULT_ACCOUNT(Web端，同一账号，多页面登录被踢)
    // TencentCloudChat.TYPES.KICKED_OUT_MULT_DEVICE(同一账号，多端登录被踢)
    // TencentCloudChat.TYPES.KICKED_OUT_USERSIG_EXPIRED(签名过期)
    // TencentCloudChat.TYPES.KICKED_OUT_REST_API(REST API kick 接口踢出)
    let reason = "";
    if (event.data.type === TencentCloudChat.TYPES.KICKED_OUT_MULT_ACCOUNT) {
      reason = "web";
    } else if (
      event.data.type === TencentCloudChat.TYPES.KICKED_OUT_MULT_DEVICE
    ) {
      reason = "platform";
    } else if (
      event.data.type === TencentCloudChat.TYPES.KICKED_OUT_USERSIG_EXPIRED
    ) {
      reason = "expire";
    } else if (event.data.type === TencentCloudChat.TYPES.KICKED_OUT_REST_API) {
      reason = "api";
    }
    this._emit(EMIT_MAP.onKickedOut, reason);
  }
  getMessageList(params = {}) {
    const { conversationID = "", nextReqMessageID = null } = params;
    return new Promise((resolve, reject) => {
      this.client
        .getMessageList({
          conversationID: conversationID,
          nextReqMessageID,
        })
        .then((imResponse) => {
          const messageList = imResponse.data.messageList; // 消息列表。
          const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
          const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
          resolve({
            messageList,
            nextReqMessageID,
            isCompleted,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  //获取群成员资料
  getGroupMemberProfile(params) {
    return new Promise((resolve, reject) => {
      const { groupID, userIDList } = params;
      this.client
        .getGroupMemberProfile({
          groupID: groupID || String(this.config.classId),
          userIDList: userIDList, // 请注意：即使只拉取一个群成员的资料，也需要用数组类型，例如：userIDList: ['user1']
          // memberCustomFieldFilter:  , // 筛选群成员自定义字段：group_member_custom
        })
        .then(function (imResponse) {
          console.log("===66getGroupMemberProfile success:", imResponse);
          const { code, data } = imResponse;
          const res = (data?.memberList || []).map((item) => {
            const { memberCustomField } = item;
            let customFieldObj = {};
            (memberCustomField || []).forEach((item) => {
              if (item.key) {
                customFieldObj[item.key] = item.value;
              }
            });
            return { ...item, ...customFieldObj };
          });
          resolve(res);
        })
        .catch(function (imError) {
          console.warn("getGroupMemberProfile error:", imError);
          reject(imError);
        });
    });
  }
  // 发送消息
  sendMessage(message, options = {}) {
    console.log("sendMessage__message", message);
    let cloudCustomData = {
      lessonId: this.config.lessonId,
      isStudent: this.config.isStudent,
      isTeacher: this.config.isTeacher,
      isAssistant: this.config.isAssistant,
    };
    if (message.cloudCustomData) {
      cloudCustomData = {
        ...JSON.parse(message.cloudCustomData),
        ...cloudCustomData,
      };
    }
    message.cloudCustomData = JSON.stringify(cloudCustomData);
    return new Promise((resolve, reject) => {
      this.client
        .sendMessage(message, options)
        .then((imRes) => {
          // 处理消息

          const { code, data } = imRes;
          if (code === 0) {
            // const { from, _elements = [], payload, type } = data.message || {};
            const res = {
              ...data.message,
              // from,
              // payload,
              type: MESSAGE_TYPE[data.message?.type],
            };
            resolve(res);
          } else {
            reject(imRes);
          }
        })
        .catch((imErr) => {
          reject(imErr);
          console.log(imErr);
        });
    });
  }
  // 发送直播间内的自定义消息
  sendMGLiveRoomCustomMsg(data) {
    return new Promise((resolve, reject) => {
      const message = this.createCustomMessage({
        to: String(this.config.classId),
        priority: "high",
        payload: {
          data: JSON.stringify(data),
          description: "",
          extension: "MGLiveRoomExt",
        },
      });
      this.sendMessage(message).then(
        (res) => {
          console.log("sendMessage>>>", res);
          resolve(res);
        },
        (error) => {
          console.log("error____sendMessage>>>", error);
          reject(error);
        }
      );
    });
  }
  // 创建文本消息
  createTextMessage(params) {
    const {
      to,
      conversationType = 2,
      text = "",
      custom,
      type,
      cloudCustomData,
    } = params;
    const data = {
      to: to,
      conversationType:
        conversationType === 1
          ? TencentCloudChat.TYPES.CONV_C2C
          : TencentCloudChat.TYPES.CONV_GROUP,
      payload: {
        text: text,
      },
      cloudCustomData,
    };
    return this.client.createTextMessage(data);
  }
  // 创建图片消息
  createImageMessage(params) {
    const {
      to,
      conversationType = 2,
      onProgress = () => { },
      cloudCustomData = "",
      payload = {},
    } = params;
    const data = {
      to,
      conversationType:
        conversationType === 1
          ? TencentCloudChat.TYPES.CONV_C2C
          : TencentCloudChat.TYPES.CONV_GROUP,
      payload,
      onProgress,
      cloudCustomData,
    };
    return this.client.createImageMessage(data);
  }
  // 创建文件消息
  createFileMessage(params) {
    const {
      to,
      conversationType = 2,
      onProgress = () => { },
      cloudCustomData = "",
      payload = {},
    } = params;
    const data = {
      to,
      conversationType:
        conversationType === 1
          ? TencentCloudChat.TYPES.CONV_C2C
          : TencentCloudChat.TYPES.CONV_GROUP,
      payload,
      onProgress,
      cloudCustomData,
    };
    return this.client.createFileMessage(data);
  }

  // 创建自定义消息
  createCustomMessage(params) {
    const {
      to,
      conversationType = 2,
      cloudCustomData = "",
      payload = {},
      priority = "normal", // 默认普通优先级  High  Normal  Low Lowest
    } = params;
    console.log("params", params);
    console.log("params>>>>", to);

    const message = this.client.createCustomMessage({
      to: to,
      conversationType:
        conversationType === 1
          ? TencentCloudChat.TYPES.CONV_C2C
          : TencentCloudChat.TYPES.CONV_GROUP,

      payload: payload,
      cloudCustomData: cloudCustomData, // 云端自定义数据，可存任何数据，长度限制为 4KB
      // 消息优先级，用于群聊。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
      // 支持的枚举值：TencentCloudChat.TYPES.MSG_PRIORITY_HIGH, TencentCloudChat.TYPES.MSG_PRIORITY_NORMAL（默认）, TencentCloudChat.TYPES.MSG_PRIORITY_LOW, TencentCloudChat.TYPES.MSG_PRIORITY_LOWEST
      priority: priority, //
    });
    return message;
  }
  async resendBoardRealtimeDataMessage(message) {
    console.log(
      ">>>> resendBoardRealtimeDataMessage:",
      this.sendMessageStatus[message.ID].resendCount
    );
    const [error] = await this.client.resendMessage(message);
    if (error && this.sendMessageStatus[message.ID]) {
      this.sendMessageStatus[message.ID].resendCount += 1; // 重试次数+1
      if (this.sendMessageStatus[message.ID].resendCount > 2) {
        // 重试3次后
        console.error("白板实时信令同步失败");
      }
    } else {
      // 成功后，删除状态
      delete this.sendMessageStatus[message.ID];
    }
  }

  // 群成员全体禁言
  muteAllGroupMembers(params) {
    return new Promise((resolve, reject) => {
      this.client
        .updateGroupProfile(params)
        .then((imRes) => {
          // 处理消息
          const { code, data } = imRes;
          if (code === 0) {
            // const { from, _elements = [], payload, type } = data.message || {};
            // const res = {
            //   from,
            //   payload,
            //   type:
            //     type === TencentCloudChat.TYPES.MSG_TEXT ? "text" : "custom",
            // };
            resolve(imRes);
          } else {
            reject(imRes);
          }
        })
        .catch((imErr) => {
          reject(imErr);
          console.log(imErr);
        });
    });
  }

  // 禁言单个群成员
  muteGroupMember(params) {
    return new Promise((resolve, reject) => {
      const { groupID, userID, muteTime } = params;
      this.client
        .setGroupMemberMuteTime(params)
        .then((imRes) => {
          const { code, data } = imRes;
          if (code === 0) {
            resolve(imRes);
          } else {
            reject(imRes);
          }
        })
        .catch((imErr) => {
          reject(imErr);
          console.log(imErr);
        });
    });
  }
  convertToIMMessage(item, userInfo) {
    return convertToIMMessage(item, userInfo);
  }
  // 撤回消息
  revokeMessage(message = {}) {
    const { ID } = message;
    if (typeof ID === "string") {
      // 走im撤回
      return this.client.revokeMessage(message);
    } else if (typeof ID === "number") {
      // 走服务撤回
      return handleRevokeMessageByServer({ id: ID });
    }
  }

  // 重新发送消息
  resendMessage(message, options = {}) {
    return new Promise((resolve, reject) => {
      this.client
        .resendMessage(message, options)
        .then((imRes) => {
          // 处理消息
          const { code, data } = imRes;
          if (code === 0) {
            const res = {
              ...data.message,
              type: MESSAGE_TYPE[data.message?.type],
            };
            resolve(res);
          } else {
            reject(imRes);
          }
        })
        .catch((imErr) => {
          reject(imErr);
        });
    });
  }
}
// 过滤消息,消息的lessonId和当前不一致，并且来源是学生，接收端也是学生
const isFilterMessage = (message, config) => {
  const cloudCustomData = JSON.parse(message.cloudCustomData || "{}");
  const messageLessonId = cloudCustomData.lessonId;
  const isFromStudent = cloudCustomData.isStudent;
  const isCurrentStudent = config.isStudent;
  console.log("isFilterMessage__message", message);
  console.log("isFilterMessage__config", config);
  console.log("isFilterMessage__messageLessonId", messageLessonId);
  console.log("isFilterMessage__isFromStudent", isFromStudent);
  console.log("isFilterMessage__isCurrentStudent", isCurrentStudent);
  if (
    messageLessonId !== config.lessonId &&
    isFromStudent &&
    isCurrentStudent
  ) {
    // 消息的来源课时id和当前课时id不一致，并且消息的来源是学生，并且接收端也是学生，则过滤
    return true;
  }
  // 消息的来源课时id和当前课时id一致，或者消息的来源不是学生，或者接收端不是学生，则不过滤
  return false;
};
export default TIMIMService;
